import React from 'react';
import LazyImage from '../../../LazyImage';
import classNames from 'classnames';
import styles from './index.module.scss';

const MobileBusinessHeader = () => {
  const businessHeaderBg = () => import('@/assets/images/header/business/business-header-bg.jpg').then((module) => ({ default: module.default }));
  const slogan = () => import('@/assets/images/header/business/slogan.png').then((module) => ({ default: module.default }));

  return (
    <div className={styles.carousel}>
      <header className={classNames(styles['carousel-container'])}>
        <LazyImage importFunc={businessHeaderBg} alt="" className={styles.businessHeaderBg} />
        <div className={classNames(styles.slogan, styles['carousel-image'])}>
          <div className={styles['slogan-title']}>
            <LazyImage importFunc={slogan} alt="商务合作" className={styles['slogan-image']} />
          </div>
          <div className={styles.contacts}>
            <address className={styles.contact}>
              <p>联系人：张先生</p>
              <p>联系电话：<a href="tel:13315285690">133 1528 5690</a></p>
              <p>邮箱：<a href="mailto:zhangyuheng@thunder.com.cn">zhangyuheng@thunder.com.cn</a></p>
            </address>
            <address className={styles.contact}>
              <p>联系人：朱女士</p>
              <p>联系电话：<a href="tel:13438063671">134 3806 3671</a></p>
              <p>邮箱：<a href="mailto:zhuyuxi@thunder.com.cn">zhuyuxi@thunder.com.cn</a></p>
            </address>
          </div>
        </div>
      </header>
    </div>
  );
};

export default MobileBusinessHeader;

